import url from '../url'
import headers from '../headers'

export default {
	getHelpContentRouteNames (context) {
		return context.$http.get(
			`${url}/helpcontent/routes/`,
			headers.bearer()
		)
	},
	getHelpContent (context, routeName) {
		return context.$http.get(
			`${url}/helpcontent/${routeName}/`,
			headers.bearer()
		)
	},
	editHelpContent (context, routeName, model) {
		return context.$http.put(
			`${url}/helpcontent/${routeName}/`,
			model,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/help.js